import { call, fork, put, select, takeLeading } from 'redux-saga/effects'
import {
  resetForm,
  setCurrentStep,
  submitForm,
  updateFormStepValuesAndSubmit,
} from './actions'
import { getSpareAxleRequestFormData } from '~store/wizardSpareAxleRequest/selectors'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { displayAPIError } from '~store/global/sagas'
import { SpareAxleRequestApi } from '~api/instances'
import { SpareAxleRequestForm } from '@saf/saf-kundenportal-frontend-api/models/SpareAxleRequestForm'
import { addToastToBeDisplayed } from '~store/global/actions'
import i18n from 'i18next'

export function* spareAxleRequestSagas() {
  yield fork(watchUpdateFormStepValuesAndSubmitForm)
}

function* watchUpdateFormStepValuesAndSubmitForm() {
  yield takeLeading(updateFormStepValuesAndSubmit, function* () {
    try {
      const SpareAxleRequestFormWizardData: SpareAxleRequestForm = yield select(getSpareAxleRequestFormData)
      yield call(submitFormWorker, { spareAxleRequestForm: SpareAxleRequestFormWizardData })
      yield put(resetForm())
      yield put(setCurrentStep('success'))
      // TODO: Zeigt momentan nur eine graue Mülltonne an. Grund ist Unbekannt
      // yield put(addToastToBeDisplayed({
      //   severity: 'success',
      //   content: i18n.t('form:spareAxleRequestFormStepSuccessHeading'),
      // }))
    } catch (e) {
      yield displayAPIError(e, 'watchUpdateFormStepValuesAndSubmitForm')
    }
  })
}

const submitFormWorker = bindAsyncAction(submitForm)(
  function* (props) {
    return yield call([SpareAxleRequestApi, SpareAxleRequestApi.sendSpareAxleRequest], props)
  },
)
